module.exports = __webpack_public_path__ + "static/wood-style-3-5f36379c02763af52e90bb89f0114444.png";